import parseNetworkError from "@utils/parse-network-error";
import * as apiMethods from "@src/services";
import keysToCamel from "@utils/keys-to-camel";
import getUtmsAndAdditionalData from "@utils/get-utms-and-additional-data";

export const SET_API_CALL_IN_PROGRESS = "SET_API_CALL_IN_PROGRESS";
export const SET_GENERAL_ERRORS = "SET_GENERAL_ERRORS";
export const SET_QUERIES = "SET_QUERIES";
export const SET_ID_VENDEDOR = "SET_ID_VENDEDOR";
export const CHANGE_SKU = "CHANGE_SKU";

export default {
  state: {
    isAPICallInProgress: false,
    generalErrors: [],
    query: {},
    callcenter: {
      id: "",
    },
  },
  mutations: {
    [SET_API_CALL_IN_PROGRESS]: (state, status) => {
      state.isAPICallInProgress = status;
    },
    [SET_GENERAL_ERRORS]: (state, error) => {
      state.generalErrors.push(error);
    },
    [SET_QUERIES]: (state, values) => {
      state.query = { ...values };
    },
    [CHANGE_SKU]: (state, sku) => {
      state.query = { ...state.query, sku };
    },
    [SET_ID_VENDEDOR]: (state, value) => (state.callcenter.id = value),
  },
  actions: {
    /**
     * Dispatch AJAX calls
     * @param {String} entity e.g. `users`
     * @param {String} action method name eg. `getById`
     */
    async api({ commit }, { entity, action, payload = {}, query, params }) {
      try {
        const response = await apiMethods[entity][action]({
          payload,
          query,
          params,
        });
        return response;
      } catch (error) {
        const errorPayload = {
          [`${entity}_${action}_request`]: parseNetworkError(error),
        };
        commit(SET_GENERAL_ERRORS, errorPayload);
        commit(SET_API_CALL_IN_PROGRESS, false);
      }
      return null;
    },
    setQueriesParams({ commit }, query) {
      if (query.modalidade) {
        commit(
          "order/SET_TYPE_LINE",
          query.modalidade.toLowerCase() === "nova"
            ? "novaLinha"
            : "manterNumero",
          true
        );
      }
      commit(SET_QUERIES, keysToCamel(query));
    },
    changeSku({ commit }, sku) {
      commit(CHANGE_SKU, sku);
    },
    setIdVendedor({ commit }, IdVendedor) {
      commit(SET_ID_VENDEDOR, IdVendedor);
    },
  },
  // https://carrinho.assineoicontrole.com.br/?&sku=OICT002CM&type=controle&utm_source=google&ddd=21
  // utm_source=google
  // utm_medium=cpc
  // utm_campaign=carrinhooi
  // utm_term=oicontroleassinar
  // utm_content=contratar
  getters: {
    getQuery: state => {
      return getUtmsAndAdditionalData(state.query);
    },
    getRawQuery: state => {
      return state.query;
    },
    company: state => state.query.company || "revendavivo",
    currentSku: state => state.query.sku,
    segmento: state => state.query.type,
    isAPICallInProgress: state => state.isAPICallInProgress,
  },
};

// http://localhost:8080/?ddd=21&sku=OICT005CM&cidade=Rio%20de%20Janeiro&uf=RJ&type=controle
